import React from 'react';
import { Box, Typography, Paper, Stack, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PageShell = ({ title, subtitle, icon, breadcrumbs = [], actions, children }) => (
  <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
    {/* Breadcrumbs */}
    {/* {breadcrumbs.length > 0 && (
      <Breadcrumbs sx={{ mb: 2, fontSize: 13 }}>
        {breadcrumbs.map((bc, i) =>
          bc.to ? (
            <Link
              key={i}
              component={RouterLink}
              to={bc.to}
              underline="hover"
              color="text.secondary"
              sx={{ fontSize: 13 }}
            >
              {bc.label}
            </Link>
          ) : (
            <Typography key={i} color="text.primary" sx={{ fontSize: 13, fontWeight: 600 }}>
              {bc.label}
            </Typography>
          )
        )}
      </Breadcrumbs>
    )} */}

    {/* Hero header */}
    <Paper
      elevation={0}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        // borderRadius: 3,
        mb: 3,
        p: { xs: 1, sm: 1 },
        background: 'linear-gradient(135deg, #011344 0%, #1e3a8a 55%, #1e3a8a 100%)',
        color: '#fff',
      }}
    >
      {/* decorative circles */}
      <Box
        sx={{
          position: 'absolute',
          width: 220,
          height: 220,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.08)',
          top: -80,
          right: -40,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: 140,
          height: 140,
          borderRadius: '50%',
          bgcolor: 'rgba(255,255,255,0.06)',
          bottom: -60,
          right: 120,
        }}
      />

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={2}
        sx={{ position: 'relative', zIndex: 1 }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          {icon && (
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2.5,
                bgcolor: 'rgba(255,255,255,0.18)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(6px)',
                '& svg': { fontSize: 30, color: '#fff' },
              }}
            >
              {icon}
            </Box>
          )}
          <Box>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ letterSpacing: -0.3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>

        {actions && <Stack direction="row" spacing={1}>{actions}</Stack>}
      </Stack>
    </Paper>

    {children}
  </Box>
);

export default PageShell;